import { $currentOrganization, loadOrganization } from './store';

$currentOrganization.on(loadOrganization, (_, organization) => organization);
